var HeritageHelper = {
  itemsData : [],
  itemsSku : [],
  productData : [],
  cartProducts:[],
  bindEvents(){
   let self = this; 
    $(".min_price_range").val(0);
    $(".max_price_range").val(this.getQueryParam('filter.v.price.lte'));
    let quote_amount = self.getQueryParam('quote_amount') ;
    
    quote_amount = isNaN(quote_amount)?0:quote_amount
    if(quote_amount!=''){
      $("input[name=max_price]").val(quote_amount);
       
    }
    if(quote_amount>0){
      $(".range-main-filter").addClass("active");
      $(".your-budget-tagline").show();
    }
    let newAmount = Number(quote_amount) + 100; 
    let formattedAmt = newAmount.toLocaleString('en-US'); 
    $(".max_range").text(formattedAmt);
    $("input[name=quote_amount]").val(quote_amount);
    
    let currentTime=new Date();
    let hours=currentTime.getHours();
    let mins=currentTime.getMinutes();
    $('.time-txt').text(`${hours}:${mins}`);
  
    $('.remove-all-products').click(function () {
        if (confirm('Are you sure you want to remove this item from the cart?')) {
            $.post('/cart/clear.js')
                .done(function () {
                    alert('Cart has been cleared.');
                    location.reload(); // Refresh the page to update the cart UI
                })
                .fail(function () {
                    alert('Failed to clear the cart. Please try again.');
                });
        }
    });
    if($('#max_price').length > 0){
        let val = $('#max_price').val().replace(/,/g, '');
        if (!isNaN(val) && val !== '') {
            let formatted = Number(val).toLocaleString('en-US');
            $('#max_price').val(formatted);
        } 
     }
    $('.remove-item').click(function (e) {
      e.preventDefault();
      if (confirm('Are you sure you want to remove all items from the cart?')) {
          window.location.href  = $('.remove-item').attr("href");
      }
    });

    $('.add-to-quote').click(function (e) {
      $(".product-form__buttons .product-form__submit").trigger("click")
      
    });
    
//   handle whatapp click
    $('.productWhatsapp').on('click', function () {
        self.handleWhatsappClick($(this));
    });

    self.displayModelpopus();
    if($('#max_price').length > 0){
        self.updateIcon();
    }
     

    //  handle sendsms product text using class
   let isSendingSms = false;
    $(document).on('click', '.productText', function () {
        if (isSendingSms) return;
        isSendingSms = true;
    
        var isCartItem = $(this).hasClass('is_cart_item');
        var username = $('.send-text #userName').val();
        var userNumber = $('#userNumber').val();
        var recaptchaResponse = document.querySelector('input[name="cf-turnstile-response"]')?.value || '';
    
        if (!userNumber || userNumber.trim() === '') {
            $('#userNumber').addClass('error');
            isSendingSms = false;
            return false;
        }
    
        let data = {
            user: {
                userName: username,
                userNumber: userNumber
            },
            recaptchaResponse: recaptchaResponse,
            items: []
        };
    
        var selector = isCartItem ? '.cart-item' : '.product';
        var skuSelector = isCartItem ? '.data_sku' : '.product-sku';
        var nameSelector = isCartItem ? '.cart-item-title' : '.product-name';
    
        document.querySelectorAll(selector).forEach(item => {
            var productSku = item.querySelector(skuSelector)?.textContent.trim() || '';
            var productName = item.querySelector(nameSelector)?.textContent.trim() || '';
            data.items.push({ sku: productSku, name: productName });
        });
        self.sendProdcutSms(data, function () {
            isSendingSms = false;  
        });
    });

        //  ----->>
    // handle  send product mail  using class
    let isSendingMail = false;
   $(document).on('click', '.productMail', function (){
     if (isSendingMail) return;
        isSendingMail = true;
        var isCartItem = $(this).hasClass('is_cart_item');

        var username = $('.userName').val() || '';
        var userEmail = $('.userEmail').val() || '';
        var recaptchaResponse = document.querySelector('input[name="cf-turnstile-response"]')?.value || '';

        if (!userEmail.trim()) {
            $('.userEmail').addClass('error');
          isSendingMail = false;
            return false;
        }
        var data = {
            user: {
                userName: username,
                userEmail: userEmail
            },
            recaptchaResponse: recaptchaResponse,
            items: []
        };

        var items = isCartItem ? document.querySelectorAll('.cart-item') : document.querySelectorAll('.product');

        items.forEach(item => {
            var sku = item.querySelector(isCartItem ? '.data_sku' : '.product-sku')?.textContent.trim() || '';
            var name = item.querySelector(isCartItem ? '.cart-item-title' : '.product-name')?.textContent.trim() || '';
            var link = isCartItem ? (item.querySelector('.cart-item__link')?.href || '') : ($('.product_link').val() || '');
            var image = isCartItem ? (item.querySelector('.cart-item__image')?.src || '') : ($('.product_image').val() || '');

            data.items.push({ sku, name, link, image });
        });

        self.sendMailForProduct(data, function () {
            isSendingMail = false;
        });
    });
    // --->
    // popup hide show 
      // $(".contant-btn").click(function () {
      //   var btnType = $(this).attr("data-type");
      //   if (typeof btnType !== "undefined" && btnType === 'text') {
      //       $('#select-sms').val('text').trigger('change');
      //   } else if (typeof btnType !== "undefined" && btnType === 'email') {
      //       $('#select-sms').val('email').trigger('change');
      //   }
      //   $(".quick-first").fadeIn(500).removeClass("hidden");
      //     $('.send-sms-btn').addClass('disabled');
      //   setTimeout(() => {
      //     self.turnstileResponse();
      //   }, 1000);
      // });
     $(".cross-order").click(function () {
        $(".quick-first").fadeOut(500);
       $('.price-pop-wrapper').fadeOut(500)
     });

     // ---->
      
      $('.setPriceFilter').on('click',function(){
        var Rangeprice = parseInt($('#max_price').val().replace(/,/g, ''));
        var newpricerange = (Rangeprice+100);
        var minPrice = (newpricerange-200)
        var maxPrice = (newpricerange+200)
        self.handlePriceRangefilter(minPrice,maxPrice,newpricerange)
      })
      $("#setPriceFilter").on('click',function(e){
         var priceRange = parseInt($('#max_price').val().replace(/,/g, ''));
            let icon = $(this).find('i');
            let checkNoProductVal=$('.checkResponse').val();
            if (priceRange !== '' && icon.hasClass('fa-rotate-right')) {
                $('#max_price').val('');
                icon.removeClass('fa-rotate-right').addClass('fa-arrow-right');
            }else{
            var minPrice = (priceRange-200)
            var maxPrice = (priceRange+200)
             if(checkNoProductVal !=='No products found'){
            self.handlePriceRangefilter(minPrice,maxPrice,priceRange)
              }
            }
      })
    let checkNoProductVal=$('.checkResponse').val();
      let amount = self.getQueryParam('quote_amount') ;
        if(checkNoProductVal=='No products found' && amount){
        $("body").find(".price-pop-wrapper").toggleClass("main")
        

        }

        $('#select-sms').on('change', function () {
        var selectedValue = $(this).val();
            if (selectedValue === 'text') {
                $('.number-field').show();
                $('.email-field').hide();
                $('.send-sms-btn').attr('id', 'sendtext');
                $('.send-sms-btn').removeClass('productMail');
                $('.send-sms-btn').addClass('productText');
                } else if (selectedValue === 'email') {
                $('.number-field').hide();
                $('.email-field').show();
                $('.send-sms-btn').attr('id', 'sendemail');
                $('.send-sms-btn').removeClass('productText');
                $('.send-sms-btn').addClass('productMail');
                }
            });
        $('#select-sms').trigger('change');
         
        $(document).on('keyup', '.number-field input, .email-field input', function (e) {
            if($(this).val().trim()!=""){
            $(this).closest("form").find(".send-sms-btn").addClass("active");
            }else{
            $(this).closest("form").find(".send-sms-btn").removeClass("active");
            }
        })
     $(document).on('keydown', '.number-field input, .email-field input', function (e) {
      
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            if ($('#sendtext').length) {
                $('.productText').trigger('click');
            } else if ($('#sendemail').length) {
                $('.productMail').trigger('click');
            }
        }
    });
    $('#max_price').on('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault(); // Prevent form submit
        $('#setPriceFilter').click(); // Trigger the button click
      }
    });
    $('#max_price').on('keyup', function () {
        var maxPriceInput = $(this).val().replace(/,/g, '');
       
        if (!isNaN(maxPriceInput) && maxPriceInput !== '') {
            var formatted = Number(maxPriceInput).toLocaleString('en-US');
            $(this).val(formatted);
        }
    });
    $('.sub-collection-selected').on('click', function () {
      var list = $(this).next('.sub-collection-list');
      $(this).toggleClass('open');
      list.slideToggle(200);
      var icon = $(this).find('.fa-solid');
      if ($(this).hasClass('open')) {
        icon.removeClass('fa-angle-down').addClass('fa-angle-up');
      } else {
        icon.removeClass('fa-angle-up').addClass('fa-angle-down');
      }
    });
   
  },
    handlePriceRangefilter(minPrice,maxPrice,priceRange){
        minPrice = (minPrice>0)?minPrice:0
        maxPrice = (maxPrice>0)?maxPrice:0
        $(".min_price_range").val(0)
        $(".max_price_range").val(maxPrice)
        $("input[name=quote_amount]").val(priceRange)
        if(priceRange>0){
          $('#FacetFiltersForm').submit();
        }
    },
turnstileResponse() {
  $('.send-sms-btn').addClass('disabled');
  if (typeof turnstile !== 'undefined') {
    $('.cf-turnstile').html(''); 
    turnstile.render('.cf-turnstile', {
      //sitekey: '0x4AAAAAAA4wJFX91HuWNImF',
      sitekey:'0x4AAAAAABto-4g4bzCKlDwD',
      callback: this.onTurnstileSuccess
    });
  }
},
onTurnstileSuccess(token) {
  $('.send-sms-btn').removeClass('disabled');
  window.turnstileVerified = true;
},

  getQueryParam(param) {
    let query = window.location.search.substring(1); 
    let vars = query.split("&"); 
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("="); 
      if (decodeURIComponent(pair[0]) === param) {
        return decodeURIComponent(pair[1]); 
      }
    }
    return null; 
  },

   updateIcon() {
      let priceVal = $('#max_price').val().replace(/,/g, '');
        let icon = $('#setPriceFilter i');

        if (priceVal !== '') {
            icon.removeClass('fa-arrow-right').addClass('fa-rotate-right');
        } else {
            icon.removeClass('fa-rotate-right').addClass('fa-arrow-right');
        }
    },
  handleWhatsappClick(element) {
        var isCartItem = element.hasClass('is_cart_item');
        var itemsData = this.collectItemData(isCartItem);
        console.log(itemsData);
        this.sendWhatsapp(itemsData);
    },
  collectItemData(isCartItem) {
        var itemsData = [];
        var selector = isCartItem ? '.cart-item' : '.product';
        var elements = document.querySelectorAll(selector);

        elements.forEach(item => {
            var productSku = item.querySelector(isCartItem ? '.data_sku' : '.product-sku')?.textContent.trim() || '';
            var productName = item.querySelector(isCartItem ? '.cart-item-title' : '.product-name')?.textContent.trim() || '';
            var productLink = isCartItem
                ? item.querySelector('.cart-item__link')?.href || ''
                : $('.product_link').val() || ''; 

            var itemData = {
                data: [{
                    sku: productSku,
                    name: productName,
                    link: productLink
                }]
            };
            itemsData.push(itemData);
        });
        return itemsData;
    },
  displayModelpopus(){
    var newcartItems = document.querySelectorAll('.cart-item');
    var i=1;
     newcartItems.forEach(item => {
       if(i==1){
      const productSku = item.querySelector('.data_sku') ? item.querySelector('.data_sku').textContent.trim() : '';
      const productLink = item.querySelector('.cart-item__link') ? item.querySelector('.cart-item__link').href : '';
      const productImage = item.querySelector('.cart-item__image') ? item.querySelector('.cart-item__image').src : '';
      const productName = item.querySelector('.cart-item-title') ? item.querySelector('.cart-item-title').textContent.trim() : '';
      console.log(productSku)
        $(".popup_inner_title").text(productName);
        $(".popup_inner_link").text(productLink);
        $("#popup_inner_link").attr('href',productLink);
          $(".popupImage").attr('src',productImage);
         }
          i++;
        }); 
  },
  sendMailForProduct(data) {
    $('#loader').removeClass('hidden');
    $(".notification").html('');
    var btn = $('#sendemail');
    if (btn.find('.btn-loader').length === 0) {
        $('<div class="btn-loader"></div>').insertBefore(btn.find('svg'));
        btn.find('svg').hide();
    }
    $.ajax({
     url: API_URL + 'email.php',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
   
      success: function (result) {
       console.log(result);
        if(result.status == 'success'){
         $('.request-wrap').removeClass('hidden');
          $('#loader').addClass('hidden');
          
        } else {
          $('#loader').addClass('hidden');
          $(".notification").html(`<span class="error">${result.message}</span>`);
        }
         
          var btn = $('#sendemail');
          btn.find('.btn-loader').remove();
          btn.find('svg').show();   
      },
      error: function (xhr, status, error) {
        console.error("Error:", error);
      },
      complete: function () {
            $('.textLoader').addClass('hidden');
            if (typeof onComplete === 'function') onComplete();
        }
    });
  },
  sendWhatsapp(data){
    const phone =WSMS_Phone;
    let message="Hi\n I would like to order following items \n ";
    i=1;
    data.forEach(item => {
      item.data.forEach(product => {
      
      message +=`Item ${i} :${product.name} (${product.sku}) \n`;
         message+=`${product.link.includes(window.location.origin)?product.link:window.location.origin+product.link} \n`
      });
       i++;
    });
    console.log(message)
    let text=encodeURIComponent(message);
    let redirect=window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${text}`,'_blank');
    return redirect;
  },
  sendProdcutSms(itemsData) {
    $('.textLoader').removeClass('hidden');
    $(".notification").html(``);
    var btn = $('#sendtext');
    if (btn.find('.btn-loader').length === 0) {
        $('<div class="btn-loader"></div>').insertBefore(btn.find('svg'));
        btn.find('svg').hide();
    }
    $.ajax({
      url:  API_URL + 'sms.php',                      
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(itemsData),
      success: function (result) {
        console.log(result);
        if(result.status == 'success'){
         $('.request-wrap').removeClass('hidden'); 
          $('.textLoader').addClass('hidden');
          
        } else {
          $('.textLoader').addClass('hidden');
          $(".notification").html(`<span class="error">${result.message}</span>`);
        }
        var btn = $('#sendtext');
        btn.find('.btn-loader').remove();
        btn.find('svg').show();  
      },
      error: function (xhr, status, error) {
        console.error("Error:", error);
      },
      complete: function () {
            $('.textLoader').addClass('hidden');
            if (typeof onComplete == 'function') onComplete();
        }
    });
  }
}
$(document).ready(function () {
  HeritageHelper.bindEvents();
  
});